import { render, staticRenderFns } from "./BottomTabView.vue?vue&type=template&id=fd7ba1e8&scoped=true&"
import script from "./BottomTabView.vue?vue&type=script&lang=js&"
export * from "./BottomTabView.vue?vue&type=script&lang=js&"
import style0 from "./BottomTabView.vue?vue&type=style&index=0&id=fd7ba1e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7ba1e8",
  null
  
)

export default component.exports